<div *ngIf="viewRequestData">
  <app-credit-card-request-form *ngIf="!isContract" [RequestIsPending]="requestIsPending"
                                [ViewRequestData]="viewRequestData" [ViewRequestFlag]="ViewRequestFlag">
  </app-credit-card-request-form>

  <app-contract *ngIf="isContract" [RequestIsPending]="requestIsPending"
                [ViewRequestData]="viewRequestData" [ViewRequestFlag]="ViewRequestFlag">
  </app-contract>
</div>
